import { FInter, FlexBox, GridBox } from "@brg/ui";
import { LayoutConst } from "core";
import { Outer } from "shared/pages/explore/styles";
import styled from "styled-components";
import { css } from "styled-components";

export const WinnerProjectWrapper = styled.div<{isLargeProject?: boolean}>`
    ${({isLargeProject}) => isLargeProject && css`
        grid-column: span 2;
    `}   
`

export const WinnerPlace = styled(FlexBox)`
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        margin-bottom: 8px;
    }
`

export const WinnerText = styled(FInter.Text)`
    font-size: 23px;
    font-weight: 600;
    line-height: 29px;
    letter-spacing: -0.02em;
    text-align: center;
    color: ${p => p.theme.competition.mainText}

`

export const Wreath = styled.img`
    width: 16px;
    height: 40px;
`

export const ShortListLabel = styled(FInter.MainTitleSmall)`
    margin: 56px 0 32px 0;
    font-size: 43px;
    line-height: 51px;
    color: ${p => p.theme.competition.mainText};

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        margin: 36px 0;
    }
`

export const WinnerDescription = styled(FlexBox)`
    width: 100%;
    font-size: 20px;
    line-height: 32px;
    color:  ${p => p.theme.competition.shortList.description.text};

    span {
        font-size: 20px;
        line-height: 32px;
    }

    a {
        font-size: 20px;
        line-height: 32px;
    }

    
    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        span {
            font-size: 13px;
            line-height: 16px;
        }

        a {
            font-size: 13px;
            line-height: 16px;
        }
    }
`;

export const WinnersBox = styled(GridBox)<{
    mobile: boolean
}>`
    grid-template-columns: ${`repeat(4, 270px)`};
    gap: 24px;
    row-gap: 36px;

     @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        grid-template-columns: ${`repeat(4, 204px)`};
    }
    @media(max-width: ${LayoutConst.screen.md}px) {
        gap: 17px;
        grid-template-columns: ${`repeat(3, 1fr)`};
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        gap: 10px;
        grid-template-columns: ${`repeat(2, 1fr)`};
    }

`;

export const ListOuter = styled(Outer)`
    @media(min-width: 992px) {
        width: 100% !important;
    }
`;import { FInter, FlexBox, GridBox } from "@brg/ui";
import { LayoutConst } from "core";
import { Outer } from "shared/pages/explore/styles";
import styled from "styled-components";
import { css } from "styled-components";

export const WinnerProjectWrapper = styled.div<{isLargeProject?: boolean}>`
    ${({isLargeProject}) => isLargeProject && css`
        grid-column: span 2;
    `}   
`

export const WinnerPlace = styled(FlexBox)`
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        margin-bottom: 8px;
    }
`

export const WinnerText = styled(FInter.Text)`
    font-size: 23px;
    font-weight: 600;
    line-height: 29px;
    letter-spacing: -0.02em;
    text-align: center;
    color: ${p => p.theme.competition.mainText}

`

export const Wreath = styled.img`
    width: 16px;
    height: 40px;
`

export const ShortListLabel = styled(FInter.MainTitleSmall)`
    margin: 56px 0 32px 0;
    font-size: 43px;
    line-height: 51px;
    color: ${p => p.theme.competition.mainText};

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        margin: 36px 0;
    }
`

export const WinnerDescription = styled(FlexBox)`
    width: 100%;
    font-size: 20px;
    line-height: 32px;
    color:  ${p => p.theme.competition.shortList.description.text};

    span {
        font-size: 20px;
        line-height: 32px;
    }

    a {
        font-size: 20px;
        line-height: 32px;
    }

    
    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        span {
            font-size: 13px;
            line-height: 16px;
        }

        a {
            font-size: 13px;
            line-height: 16px;
        }
    }
`;

export const WinnersBox = styled(GridBox)<{
    mobile: boolean
}>`
    grid-template-columns: ${`repeat(4, 270px)`};
    gap: 24px;
    row-gap: 36px;

     @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        grid-template-columns: ${`repeat(4, 204px)`};
    }
    @media(max-width: ${LayoutConst.screen.md}px) {
        gap: 17px;
        grid-template-columns: ${`repeat(3, 1fr)`};
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        gap: 10px;
        grid-template-columns: ${`repeat(2, 1fr)`};
    }

`;

export const ListOuter = styled(Outer)`
    @media(min-width: 992px) {
        width: 100% !important;
    }
`;